import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar/Navbar';
import Demo from '../Pages/Demo/Demo';
import TitleMeta from '../Components/TitleMeta/TitleMeta';
import NavbarMobile from '../Components/NavbarMobile/NavbarMobile';
import BtnWhatsapp from '../Components/BtnWhatsapp/BtnWhatsapp';
import Favoritos from '../Components/Favoritos/Favoritos';
import { useMediaQuery } from '@react-hook/media-query';
import baseURL from '../Components/url';
import MetaPixelLoader from '../Components/MetaPixel/MetaPixelLoader';
export default function IndexLayout() {
    const isMobile = useMediaQuery('(max-width: 1024px)');
    useEffect(() => {
        const k = localStorage.getItem('sessionKey') || (() => { const v = `${Date.now()}-${Math.random().toString(16).slice(2)}`; localStorage.setItem('sessionKey', v); return v; })();
        const beat = () => { try{ fetch(`${baseURL}/onlineHeartbeat.php`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ key: k }) }); }catch(_){ } };
        beat();
        const i = setInterval(beat, 30000);
        return () => clearInterval(i);
    }, []);
    return (
        <div className='section-bg-color'>
            <MetaPixelLoader />
            <TitleMeta />
            <Navbar />
            <div className='espaciobg'>
            </div>
            <div style={{ paddingBottom: isMobile ? '84px' : '0' }}>
                <Demo />
            </div>
            <NavbarMobile />
            <Favoritos />
            <BtnWhatsapp />
        </div>
    );
}
